<h2 mat-dialog-title>{{ subject }}</h2>
<mat-dialog-content>
  <mat-progress-bar *ngIf="!html && !failed" mode="indeterminate"></mat-progress-bar>
  <p *ngIf="failed" class="error">{{ 'CLIENT_REPORT.LOAD_FAILED' | translate }}</p>
  <iframe *ngIf="html" [srcdoc]="html" sandbox="allow-same-origin" [title]="subject"></iframe>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'CLOSE' | translate }}</button>
</mat-dialog-actions>
